import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { LEDGER_SNAPSHOT_EXTENTION } from "@frameworks/web/redux/interfaces/Reports/ILedgerSnapShot";
class LedgerSnapShotExtentionActions extends OnePlatformCommonActions {
    snapShotExtention(snapShotExtention, type) {
        this.dispatch({
            type: LEDGER_SNAPSHOT_EXTENTION,
            payload: { snapShotExtention },
            reducerName: type,
        });
    }
}
export default LedgerSnapShotExtentionActions;
